import { useEffect, useRef } from 'react';

const DEFAULT_IDLE_MS = 15 * 60 * 1000;
const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'visibilitychange'];

/**
 * Déconnecte l'utilisateur après une période d'inactivité (toutes pages).
 */
export default function useIdleLogout({ enabled, onIdle, timeoutMs = DEFAULT_IDLE_MS }) {
  const timerRef = useRef(null);
  const onIdleRef = useRef(onIdle);

  useEffect(() => {
    onIdleRef.current = onIdle;
  }, [onIdle]);

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined;

    const clearTimer = () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };

    const arm = () => {
      clearTimer();
      timerRef.current = window.setTimeout(() => {
        onIdleRef.current?.();
      }, timeoutMs);
    };

    const onActivity = () => {
      if (document.visibilityState === 'hidden') return;
      arm();
    };

    arm();
    ACTIVITY_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, onActivity, { passive: true });
    });

    return () => {
      clearTimer();
      ACTIVITY_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, onActivity);
      });
    };
  }, [enabled, timeoutMs]);
}
